export const attributionViewerKeys = {
  jobs: (meetingId: string) => ['attribution-jobs', meetingId] as const,
  artifactScope: (meetingId: string) => ['attribution-artifact', meetingId] as const,
  artifact: (meetingId: string, kind: 'live' | 'refined' | 'raw' | 'observations', jobId: string | null = null) =>
    kind === 'refined'
      ? ([...attributionViewerKeys.artifactScope(meetingId), kind, jobId] as const)
      : ([...attributionViewerKeys.artifactScope(meetingId), kind] as const),
  providers: (meetingId: string, revision: string | null) =>
    [...attributionViewerKeys.artifactScope(meetingId), 'providers', revision] as const,
  annotationRaw: (meetingId: string, prefillVersion: string, rawSha256: string) =>
    [...attributionViewerKeys.artifactScope(meetingId), 'annotation-raw', prefillVersion, rawSha256] as const,
  speakerMapScope: (meetingId: string) => ['attribution-speaker-map', meetingId] as const,
  speakerMap: (meetingId: string, jobId: string | null = null) =>
    [...attributionViewerKeys.speakerMapScope(meetingId), jobId] as const,
  liveReplay: (meetingId: string) => ['attribution-live-replay', meetingId] as const,
  relabeler: (meetingId: string) => ['attribution-relabeler', meetingId] as const,
  shippedRecord: (meetingId: string, revision: string | null) =>
    [...attributionViewerKeys.relabeler(meetingId), 'shipped', revision] as const,
  turnPreferenceScope: (meetingId: string) => ['attribution-turn-preference', meetingId] as const,
  turnPreference: (meetingId: string) => [...attributionViewerKeys.turnPreferenceScope(meetingId), 'session'] as const,
  audioScope: (meetingId: string) => ['attribution-audio', meetingId] as const,
  audio: (meetingId: string, jobId: string | null = null) =>
    [...attributionViewerKeys.audioScope(meetingId), 'playback', jobId] as const,
}
